import { render, staticRenderFns } from "./StudentUpload.vue?vue&type=template&id=0f747bc5&"
import script from "./StudentUpload.vue?vue&type=script&lang=ts&"
export * from "./StudentUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports